import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function LatestCollections() {
  const [featured, ...rest] = articles;

  return (
    <section className="mx-auto max-w-content px-4 md:px-6 py-14 md:py-20">
      <SectionHeading
        eyebrow="精选合集"
        title="本周最完整的几份档案"
        desc="每一份档案都包含事件简介、逐条时间线、素材清单与相关推荐，读一篇就能掌握全程。"
        action={
          <Link
            to="/collections"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            全部合集
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />

      <ArticleCard article={featured} variant="hero" />

      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {rest.map((item) => (
          <ArticleCard key={item.slug} article={item} />
        ))}
      </div>
    </section>
  );
}